"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComboboxLoadingStateMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var ComboboxLoadingStateMixin = (0, _styledToken.default)('ComboboxLoadingState.verticalSpacing', function (verticalSpacing) {
  return (0, _styledComponents.css)(["display:flex;justify-content:center;align-items:center;padding-top:", "px;padding-bottom:", "px;"], verticalSpacing, verticalSpacing);
});
exports.ComboboxLoadingStateMixin = ComboboxLoadingStateMixin;